import { render, staticRenderFns } from "./UserTrustPointsTable.vue?vue&type=template&id=597fa4ea&scoped=true&"
import script from "./UserTrustPointsTable.vue?vue&type=script&lang=js&"
export * from "./UserTrustPointsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserTrustPointsTable.vue?vue&type=style&index=0&id=597fa4ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597fa4ea",
  null
  
)

export default component.exports